const NO_TIME_FILTER = '0000';

const isValidDepartureTime = (departureTime) =>
    departureTime != null && departureTime !== NO_TIME_FILTER;

export const composeTimeSelectParams = (segments) => {
    const { departureTime } = segments[0] || {};
    if (!isValidDepartureTime(departureTime)) return '';
    return `;depTime=${departureTime}`;
};
